import { Accordion } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { HtmlContent } from '../../components/HtmlContent';
import { accordionClick } from '../analytics/helper';

export function restrictOnChange(regex, originalHandler) {
  return function restrictOnChangeHandler(e) {
    const event = {
      target: {
        name: e.target.name,
        value: e.target.value.replace(regex, '')
      }
    };
    originalHandler(event);
  };
}

export function formatPriceToLocale(price, decimals, locale) {
  return price.toLocaleString(locale, {
    minimumFractionDigits: decimals
  });
}

export const initialValue = (value, initValue) => {
  if (value === undefined) {
    return initValue;
  }
  return value;
};

export function formatInteger(number) {
  if (number !== undefined) {
    return number
      .toString()
      .replace(/\./g, ',')
      .replace(/\D,+/g, '')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }
  return null;
}

export function renderAccordion(content) {
  if (typeof content === 'string') {
    return null;
  }
  try {
    React.useEffect(() => {
      const accordions = document.querySelectorAll('.c-accordion__header.js-accordion__title');

      accordions.forEach(item => {
        item.addEventListener('click', accordionClick);
      });
      return () => {
        accordions.forEach(item => {
          item.removeEventListener('click', accordionClick);
        });
      };
    });
  } catch (error) {
    window.log(`${error}`);
  }

  return (
    <Accordion>
      {content.map(item => (
        <Accordion.Item key={item.title} title={item.title} titleLevel={4}>
          <HtmlContent>{item.text}</HtmlContent>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}

export const reverseDate = (date, currentSeparator = '.', newSeparator = '-') =>
  date &&
  date
    .split(currentSeparator)
    .reverse()
    .join(newSeparator);

export const dateToISOString = date =>
  date ? new Date(reverseDate(date)).toISOString().split('T')[0] : '';

export const generatePDFFileFromBase64 = b64String => {
  const byteCharacters = atob(b64String);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  let windowOpen;
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    windowOpen = window.navigator.msSaveOrOpenBlob(blob, 'Dokument.pdf');
  } else if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
    windowOpen = window.open(`data:application/pdf;base64, ${encodeURI(b64String)}`);
  } else {
    const fileObjectURL = URL.createObjectURL(blob);
    windowOpen = window.open(fileObjectURL);
  }
  if (windowOpen == null || typeof windowOpen === 'undefined') {
    throw new Error('Pop-up Prevented');
  }
};

export const addQueryParams = (baseUrl, queryParams) => {
  const queryString = queryParams.reduce((result, element, currentIndex) => {
    const separator = currentIndex === 0 ? '' : '&';
    const resultQuery = `${result}${
      element.value ? `${separator}${element.name}=${element.value}` : ''
    }`;

    return resultQuery;
  }, '');
  return `${baseUrl}${queryString === '' ? '' : `?${queryString}`}`;
};

export const sanitizeTransactionIdAtQueryParams = () => {
  let transactionId, transactionIdQueryParam = null;
  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.has('transactionId')) {
    transactionIdQueryParam = searchParams.get('transactionId');
    transactionId = transactionIdQueryParam.replace(/[^a-zA-Z0-9-]/g, '');

    if (transactionIdQueryParam !== transactionId) {
      searchParams.set('transactionId', transactionId);
      window.location.search = searchParams.toString();
    }
  }

  return (transactionId && transactionId.length === 36) ? transactionId : null;
};

export const addTransactionId = (baseUrl, transactionId) => {
  if (!transactionId) return baseUrl;

  return `${baseUrl}?transactionId=${transactionId}`;
};

const determinePricingManufacturer = (config, heycarpromotion) => {
  if (config && config.appConfig.resourceKey === 'vwfs') {
    return heycarpromotion.manufacturer;
  }

  return config.manufacturer || undefined;
};

export const getPricingServiceProps = (config, step1Data, resourceKey, heycarpromotion) => {
  const manufacturer = determinePricingManufacturer(config, heycarpromotion);
  let selectedManufacturer;
  if (config.appConfig.resourceKey === 'vwfs') {
    selectedManufacturer = heycarpromotion.manufacturer;
  } else {
    selectedManufacturer = manufacturer;
  }

  const contractProductID = step1Data.contractProductID || '';
  return {
    ...step1Data,
    manufacturer,
    selectedManufacturer,
    contractProductID,
    resourceKey
  };
};

export const getBrand = (brand, stepData, config) => {
  // eslint-disable-next-line consistent-return
  const result = brand.find(item => {
    return (
      stepData.contractBrand === item ||
      config.appConfig.brandName === item ||
      process.env.REACT_APP_WEBSITE_BRAND === item
    );
  });
  return result !== undefined;
};

export const mapBrand = brandId => {
  let correctBrandId;
  switch (brandId) {
    case 'audi':
      correctBrandId = 'Audi';
      break;
    case 'seat':
      correctBrandId = 'SEAT';
      break;
    case 'skoda':
      correctBrandId = 'Skoda';
      break;
    case 'cupra':
      correctBrandId = 'Cupra';
      break;
    default:
      correctBrandId = brandId;
      break;
  }
  return correctBrandId;
};
